import { mountBrightcovePosterPlayer } from './shared-brightcove-embed';

export function mount(root: HTMLElement): void {
  root.querySelectorAll<HTMLElement>('[data-brightcove-player]').forEach(player => {
    mountBrightcovePosterPlayer(player, {
      frameClassName:
        player.dataset.frameClass ||
        player.dataset.iframeClass ||
        'media-with-caption__video-frame',
      playButtonSelector: '[data-brightcove-play]'
    });
  });
}
